google.maps.event.addDomListener(window, 'load', function() {
  var map = new google.maps.Map(document.getElementById('map-canvas'), {
    center: new google.maps.LatLng(38.569011, -96.320213),
    zoom: 5, // Default zoom level
    mapTypeId: google.maps.MapTypeId.ROADMAP
  });

  var panelDiv = document.getElementById('panel');
  var data = new StoreLocatorDataSource;

  var view = new storeLocator.View(map, data, {
    geolocation: false,
    features: data.getFeatures()
  });

  new storeLocator.Panel(panelDiv, {
    view: view
  });

  var geocoder = new google.maps.Geocoder();
  var input = document.getElementById('locationInput');
  var locateButton = document.getElementById('locate-button');
  var distanceSelector = document.getElementById('distance-selector');

  var autocomplete = new google.maps.places.Autocomplete(input);

  locateButton.addEventListener('click', function() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        var userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        map.setCenter(userLocation);

        new google.maps.Marker({
          position: userLocation,
          map: map,
          title: 'You are here'
        });
      }, function() {
        handleLocationError(true, map.getCenter());
      });
    } else {
      handleLocationError(false, map.getCenter());
    }
  });

  autocomplete.addListener('place_changed', function() {
    var place = autocomplete.getPlace();
    if (!place.geometry) {
      geocodeAddress(input.value);
      return;
    }

    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
      map.setZoom(9);
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(9);  
    }
    new google.maps.Marker({
      map: map,
      position: place.geometry.location
    });
  });

  // Event listener for distance selector
  distanceSelector.addEventListener('change', function() {
    var zoomLevel = parseInt(this.value);
    map.setZoom(zoomLevel);
  });

  function handleLocationError(browserHasGeolocation, pos) {
    var infoWindow = new google.maps.InfoWindow({
      map: map,
      position: pos,
      content: browserHasGeolocation ?
                'Error: The Geolocation service failed.' :
                'Error: Your browser doesn\'t support geolocation.'
    });
  }
});